module.exports = __webpack_public_path__ + "assets/img/schema_bg@2x.8d55462c.png";